import React from 'react'

import { IContentfulSmallLeadForm } from '../../logic/shared-types'
import { SubscriptionForm } from '../SubscriptionForm'

import './SmallLeadForm.scss'

export const SmallLeadForm = ({
  section,
  pageSlug,
}: {
  section: IContentfulSmallLeadForm
  pageSlug: string
}) => {
  return (
    <div className="smallLeadForm">
      <SubscriptionForm
        sectionId={section.contentful_id}
        pageSlug={pageSlug}
        {...section}
      />
    </div>
  )
}
